import { View } from "react-native";
import { Chip, Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import { VariantWithOptions } from "../../types";
type Props = {
  variantOptions: VariantWithOptions[];
  enabledFilters: string[];
  toggleFilter: (option: string) => void;
};

export default function VariantOptionFilters({
  variantOptions,
  enabledFilters,
  toggleFilter,
}: Props) {
  const tailwind = useTailwind();
  return (
    <View>
      <Text variant="titleMedium">Filtra las opciones que desees manejar</Text>
      {variantOptions.map(({ variant, options }, variantIndex) => (
        <View key={variantIndex} style={tailwind("mt-2")}>
          <Text variant="titleSmall" numberOfLines={1}>
            {variant.name}
          </Text>
          <View style={tailwind("flex-row flex-wrap")}>
            {options.map((option, optionIndex) => (
              <Chip
                key={optionIndex}
                showSelectedOverlay
                selected={enabledFilters.includes(option.name)}
                onPress={() => toggleFilter(option.name)}
                style={tailwind("mr-2 mt-2")}
              >
                {option.name}
              </Chip>
            ))}
          </View>
        </View>
      ))}
    </View>
  );
}
